import { Component, OnInit } from '@angular/core';
import { InputSwitchModule } from 'primeng/inputswitch';
import { MessageService } from 'primeng/api';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { MockService } from '../../../services/mock.service';

interface DataLayerType {
  name: string;
}

@Component({
  selector: 'app-role-datalayer-types',
  standalone: true,
  imports: [InputSwitchModule, TableModule, ToastModule],
  templateUrl: './role-datalayer-types.component.html',
  styleUrl: './role-datalayer-types.component.scss',
})
export class RoleDatalayerTypesComponent implements OnInit {
  access = false;
  dataLayerTypes!: DataLayerType[];
  selectedDataLayerTypes!: DataLayerType;

  constructor(
    private mockService: MockService,
    private messageService: MessageService
  ) {}

  /**
   * Lifecycle hook that is called after Angular has initialized all data-bound properties of a directive.
   * This method retrieves data layer types from the mock service and assigns them to the component's property.
   *
   * @return {void} Does not return any value.
   */
  ngOnInit(): void {
    this.mockService.getDataLayerType().then(data => {
      this.dataLayerTypes = data;
    });
  }

  /**
   * Toggles the access state and logs the result message.
   *
   * @return {void} No return value.
   */
  accessToggle(): void {
    this.access = !this.access;
    this.messageService.add(
      this.access
        ? {
            severity: 'success',
            summary: 'Aktualisiert',
            detail: 'Zugriff gewährt',
          }
        : {
            severity: 'error',
            summary: 'Aktualisiert',
            detail: 'Zugriff verweigert',
          }
    );
  }
}
